module.exports = __webpack_public_path__ + "img/City3.png";